<div class="scrollable-quicksearch--wrapper scrollable-quicksearch--has-no-filter-btn">
  <mat-form-field class="col__ no-label mb-0 bblr-0 bbrr-0"
                  [ngClass]="{'loading': loading}"
                  *ngIf="!hideSearchInput">
    <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-magnifying-glass"
              class="color--gray--007"
              *ngIf="!loading"></mat-icon>
    <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-spinner"
              class="color--gray--007 fa-spin"
              *ngIf="loading"></mat-icon>
    <input matInput
           placeholder="Search responses"
           appAutofocus
           [appAutofocusDisabled]="autoFocusDisabled"
           #searchElement="autofocus"
           [formControl]="filterInput"
           (keydown.arrowdown)="onSearchArrowDown()"
           name="response-search"
           autocomplete="off">
  </mat-form-field>
  <div class="select-all-tags-wrap p-0100 pt-0062 pb-0062 bg-color--gray--000"
       *ngIf="(allowSelectAll && totalCount > 0) && !selectAllLoading">
    <button class="link link--noline p-0 min-height-0 tile__heading mb-0 color--blue"
            (click)="selectAllClicked()">
      <i class="txt-14 mr-0025"
         [ngClass]="getSelectAllIcon()"></i>
      Select All {{totalCount}} Results
    </button>
  </div>
  <ng-container>
    <div class="select-all-tags-wrap p-0100 pt-0062 pb-0062 bg-color--gray--000"
         *ngIf="!allowSelectAll && (allowSelectMax && totalCount > 0) && !selectAllLoading">
      <button class="link link--noline p-0 min-height-0 tile__heading mb-0 color--blue"
              (click)="selectMaxClicked()">
        <i class="txt-14 mr-0025"
           [ngClass]="getSelectAllIcon()"></i>
        Select {{ getSelectMaxCount() }} Results
      </button>
    </div>
    <div class="select-all-tags-wrap caps p-0100 pt-0062 pb-0062 bg-color--gray--000"
         *ngIf="selectAllLoading">
      <i class="fal fa-spinner-third fa-spin mr-0050"></i> Loading...
    </div>
  </ng-container>
  <ng-content></ng-content>
  <section (keydown)="onResultsListKeydown($event)"
           tabindex="0">

    <!-- Custom template rendered here
        for no results, otherwise default is used
        should have structural directive *responseNoResultsTmpl
        -->
    <ng-container *ngIf="results.length === 0">
      <ng-container *ngIf="noResultsTemplate">
        <ng-container *ngTemplateOutlet="noResultsTemplate">
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!noResultsTemplate">
        <div class="result p-0100 flexJustify--between flexWrap--nowrap color--gray">
          <i class="fal fa-spinner-third fa-spin mr-0050"
             *ngIf="initLoading"></i>
          <span *ngIf="!initLoading">No Results</span>
        </div>
      </ng-container>
    </ng-container>

    <cdk-virtual-scroll-viewport class="scrollable-quicksearch__results"
                                 itemSize="{{listItemSize}}"
                                 #scrollContainer
                                 minBufferPx="250"
                                 maxBufferPx="800"
                                 [ngStyle]="{'height':results.length >= maxListItemsInScroller ? '250px' : results.length * listItemSize + 'px'}">
      <ng-container *cdkVirtualFor="let response of results">

        <app-list-item [item]="response"
                       (click)="itemClicked(response)"
                       class="result flexJustify--between
                                flexWrap--nowrap c-pointer">

          <!-- Custom template rendered here
                         should have structural directive
                        <span *responseItemTmpl="let response = response">{{response.name}}</span>
                    -->

          <ng-container *ngTemplateOutlet="responseItemTemplate; context: { response: response }">
          </ng-container>

        </app-list-item>

      </ng-container>
    </cdk-virtual-scroll-viewport>
  </section>
</div>
